module.exports = __webpack_public_path__ + "img/tel-fijo.73147593.svg";